import { render, staticRenderFns, recyclableRender, components } from "./details_dca.vue?vue&type=template&id=5fa30992&scoped=true&"
var renderjs
import script from "./details_dca.vue?vue&type=script&lang=js&"
export * from "./details_dca.vue?vue&type=script&lang=js&"
import style0 from "./details_dca.vue?vue&type=style&index=0&id=5fa30992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa30992",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/details_dca/details_dca.vue"
export default component.exports